// test1696
(1696 && 0);
